// import bd_flag from "../../../assets/icons/bd_flag.ico";
import convertBDTimeToLocal from "../../utils/convertBDTimeToLocal";
export default function AqeedahSchedule() {
  const courseSchedules = {
    level1: [
      { activity: "ক্লাস + কুইজ", day: "Sunday", time: "19:30" },
      { activity: "ক্লাস + কুইজ", day: "Tuesday", time: "19:30" },
      { activity: "ক্লাস + কুইজ", day: "Thursday", time: "19:30" },
    ],
    level2: [
      { activity: "ক্লাস + কুইজ", day: "Monday", time: "19:30" },
      { activity: "ক্লাস + কুইজ", day: "Wednesday", time: "19:30" },
      { activity: "ক্লাস + কুইজ", day: "Thursday", time: "20:30" },
    ],
    level3: [
      { activity: "ক্লাস + কুইজ", day: "Monday", time: "16:00" },
      { activity: "ক্লাস + কুইজ", day: "Tuesday", time: "16:00" },
      { activity: "ক্লাস + কুইজ", day: "Wednesday", time: "16:00" },
      { activity: "ক্লাস + কুইজ", day: "Thursday", time: "16:00" },
    ],
  };

  return (
    <section className="my-24">
      <div className="flex items-center">
        <span className="text-xl">ক্লাসের সময়ঃ </span>
        {/* <div className="ml-3">
          <img className="" src={bd_flag} alt="" />
        </div> */}
        <span className="ml-3">
          আপনার স্থানীয় সময় ({Intl.DateTimeFormat().resolvedOptions().timeZone})
          অনুযায়ী
        </span>
      </div>

      <div className="my-10 py-10 bg-green-200 rounded schedule_card">
        <div className="text-xl text-center my-10">
          <p className="">সহীহ আক্বীদাহ কোর্স- লেভেল ১</p>
          <p className=""> সপ্তাহে ৩ দিন</p>
        </div>
        <div className="overflow-x-auto ">
          <table className="table  w-3/4 mx-auto text-xl ">
            <thead>
              <tr>
                <th></th>
                <th className="text-xl">
                  সময়
                  <span className="text-sm ml-3">
                    {Intl.DateTimeFormat()
                      .resolvedOptions()
                      .timeZone.split("/")[1]
                      .toUpperCase()}
                  </span>
                </th>
                <th className="text-xl">কার্যক্রম</th>
              </tr>
            </thead>
            <tbody>
              {courseSchedules.level1.map((schedule, index) => (
                <tr key={schedule.day}>
                  <td>{index + 1}</td>
                  <td>{convertBDTimeToLocal(schedule.day, schedule.time)}</td>
                  <td>{schedule.activity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="my-10 py-10 bg-teal-200 rounded schedule_card">
        <div className="text-xl text-center my-10">
          <p className="">সহীহ আক্বীদাহ কোর্স- লেভেল ২</p>
          <p className=""> সপ্তাহে ৩ দিন</p>
        </div>
        <div className="overflow-x-auto ">
          <table className="table  w-3/4 mx-auto text-xl ">
            <thead>
              <tr>
                <th></th>
                <th className="text-xl">
                  সময়
                  <span className="text-sm ml-3">
                    {Intl.DateTimeFormat()
                      .resolvedOptions()
                      .timeZone.split("/")[1]
                      .toUpperCase()}
                  </span>
                </th>
                <th className="text-xl">কার্যক্রম</th>
              </tr>
            </thead>
            <tbody>
              {courseSchedules.level2.map((schedule, index) => (
                <tr key={schedule.day}>
                  <td>{index + 1}</td>
                  <td>{convertBDTimeToLocal(schedule.day, schedule.time)}</td>
                  <td>{schedule.activity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="my-10 py-10 bg-orange-200 rounded schedule_card">
        <div className="text-xl text-center my-10">
          <p className="">সহীহ আক্বীদাহ কোর্স- লেভেল ৩</p>
          <p className=""> সপ্তাহে ৪ দিন</p>
        </div>
        <div className="overflow-x-auto ">
          <table className="table  w-3/4 mx-auto text-xl ">
            <thead>
              <tr>
                <th></th>
                <th className="text-xl">
                  সময়
                  <span className="text-sm ml-3">
                    {Intl.DateTimeFormat()
                      .resolvedOptions()
                      .timeZone.split("/")[1]
                      .toUpperCase()}
                  </span>
                </th>
                <th className="text-xl">কার্যক্রম</th>
              </tr>
            </thead>
            <tbody>
              {courseSchedules.level3.map((schedule, index) => (
                <tr key={schedule.day}>
                  <td>{index + 1}</td>
                  <td>{convertBDTimeToLocal(schedule.day, schedule.time)}</td>
                  <td>{schedule.activity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
